import { Injectable } from '@angular/core';
import { AgreementStatusesApi } from 'src/app/lib/apis/agreement-statuses/agreement-statuses-api';
import { firstValueFrom } from 'src/app/utils/first-value-from';
import { AgreementStatuses } from './agreement-statuses';

@Injectable({ providedIn: 'root' })
export class AgreementStatusesRepository {
  constructor(private readonly api: AgreementStatusesApi) {}

  async get(uid: string): Promise<AgreementStatuses | null> {
    const res = await firstValueFrom(this.api.get(uid));
    if (res === undefined) {
      return null;
    }
    return new AgreementStatuses(res.privacy_policy, res.terms_of_service);
  }

  set(uid: string, agreementStatuses: AgreementStatuses): Promise<void> {
    return this.api.set(uid, {
      privacy_policy: agreementStatuses.privacyPolicy.valueOf(),
      terms_of_service: agreementStatuses.termsOfService.valueOf(),
    });
  }
}
